import { IPillProps, Pill } from 'components/ui';
import { useWhiteLabelContext } from 'components/white-label';
import { Edit06, Ethena01, LifeLabs01 } from 'ethena-icons';
import { Organization } from 'lib/types/company';

// TODO: Support color overrides for custom pill

interface ILogoPillProps {
  className?: string;
  isCustom?: boolean;
}

export const LogoPill = ({ className, isCustom = false }: ILogoPillProps) => {
  const { organization } = useWhiteLabelContext();

  const getPillProps = (): {
    color: IPillProps['color'];
    icon: IPillProps['icon'];
  } => {
    if (isCustom) {
      return {
        color: 'dark-yellow',
        icon: Edit06,
      };
    }

    return organization === Organization.LIFE_LABS
      ? { color: 'pink', icon: LifeLabs01 }
      : { color: 'orange', icon: Ethena01 };
  };

  return <Pill className={className} isCircular {...getPillProps()} />;
};
